"use client";

import dynamic from "next/dynamic";

const AdSwitcher = dynamic(() => import("@/components/Ads/DomainAdSwitcher"), {
  ssr: false,
});

const RichMedia = dynamic(
  () => import("@/components/Ads/AdComponent").then((mod) => mod.RichMedia),
  {
    ssr: false,
  },
);

export { AdSwitcher, RichMedia };
